<template>
  <li class="lc__item">
    <div class="lc__btn" @click="openOrder">
      Заявка #<span>{{ formatId }}</span> для <span>{{ formatName }}</span> от
      {{ item.time }}
      <span style="margin-right: 1rem" />
      <label @click.stop="">
        <input
          type="text"
          v-model.lazy="comment"
          class="lc__input"
          placeholder="Комментарий"
        />
      </label>
    </div>
    <button type="button" class="lc__delete" @click="deleteOrder">
      Удалить
    </button>
  </li>
</template>

<script>
import wNumb from "wnumb";

export default {
  name: "Main-order",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  created() {
    if (this.item?.comment === undefined) {
      this.updateComment();
    }
  },
  computed: {
    formatId() {
      return wNumb({ thousand: "-" }).to(this.item.number);
    },
    formatName() {
      return this.item.user.length >= 1 ? this.item.user : "Без имени";
    },
    comment: {
      get() {
        return this.item.comment ?? "";
      },
      set(val) {
        this.item.comment = val;
      }
    }
  },
  watch: {
    comment() {
      this.updateComment();
    }
  },
  methods: {
    updateComment() {
      this.$store.dispatch("updateOrderComment", {
        order: this.item.order,
        comment: this.comment
      });
    },
    openOrder() {
      this.$router.push({ name: "PageItem", params: { id: this.item.order } });
    },
    deleteOrder() {
      let isConfirm = confirm(
        `Удалить заявку #${this.formatId} для ${this.formatName}?`
      );
      if (isConfirm) {
        this.$store.dispatch("deleteOrder", this.item);
      }
    }
  }
};
</script>
